import { combineReducers } from 'redux'

import accountInvestigationReducer from './AccountInvestigation/reducer'
import threatLogReducer from './ThreatLog/reducer'

export default function () {
  const initialState = combineReducers({
    self: threatLogReducer,
    accountInvestigation: accountInvestigationReducer,
  })

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
